import { twColors } from 'src/shared/lib/color.utils';

export const DEFAULT_TIMEFRAME = 14;

export const DAILY_TO_WEEKLY_BUCKET_THRESHOLD = 180;

export const BOTTOM_CARD_HEIGHT = 426;

export const PAGE_BREAKPOINT = 1400; // keep identical to tailwind 2xl breakpoint

export const METRIC_COLUMN_WIDTH = 44; // used for bottom table column widths. Used as percentage of the table width for first column

export const TIMEFRAMES = {
  '7': 'Week',
  '14': '2 Weeks',
  '28': 'Month',
  '84': 'Quarter',
  '365': 'Year',
};

export const LOADING_DATA = [
  { x: 0, count: 0, previousCount: 0 },
  { x: 1, count: 70, previousCount: 35 },
  { x: 2, count: 40, previousCount: 20 },
  { x: 3, count: 60, previousCount: 30 },
  { x: 4, count: 40, previousCount: 20 },
  { x: 5, count: 60, previousCount: 30 },
  { x: 6, count: 120, previousCount: 60 },
];

export const TOGGLEPOINTS = [1, 6, 12, 24, 72];

export function getNextTogglePoint(togglePoint: number) {
  const index = TOGGLEPOINTS.indexOf(togglePoint);
  if (index === TOGGLEPOINTS.length - 1) {
    return TOGGLEPOINTS[index];
  }
  return TOGGLEPOINTS[index + 1];
}

export const DASHBOARD_COLORS = [
  twColors.dashboardblue[500],
  twColors.dashboardblue[400],
  twColors.dashboardblue[300],
  twColors.dashboardblue[200],
  twColors.dashboardblue[100],
];

export const FILL_COLORS = [
  'fill-dashboardblue-500',
  'fill-dashboardblue-400',
  'fill-dashboardblue-300',
  'fill-dashboardblue-200',
  'fill-dashboardblue-100',
];
